<template>
  <grid-component
    isResizable
    isReorderable
    :gridId="gridId"
    :itemData="itemData"
    :fields="fields"
    :onDelete="onDelete"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridSettings from '@/shared/components/GridSettings';
import GridComponent from '@/shared/components/GridComponent';
import fields from './fields';

export default {
  props:{
    billPaymentId: 0
  },
  components: {
    GridSettings,
    GridComponent
  },
  data: () => ({
    prepareColumnsData,
    fields,
    gridId: GRID_ID.BILL_PAYMENTS_DETAIL
  }),
  computed: {
    ...mapGetters('billPayments', ['selectedItemId','billPaymentLines']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData() {
      return this.billPaymentLines.map((BillPayment) => ({ ...BillPayment }));
    },
  },
  methods: {
    ...mapActions('billPayments', ['getByLines','deleteByLineId']),
    ...mapActions('account', ['saveGridSettings']),
    async onDelete({id,billPaymentId}) {
      const deleteConfirmed = await this.openConfirmBox({ message: 'Are you sure you want to delete payment?  This action cannot be undone.' });
      if (deleteConfirmed) {
        await this.deleteByLineId({ id, billPaymentId });
        //Get the data
        this.getByLines(this.billPaymentId);
      }
    }
  },
  watch: {
    billPaymentId(){
      this.getByLines(this.billPaymentId);
    }
  },
  mounted() {
     if(this.billPaymentId) { this.getByLines(this.billPaymentId);}
  },
};
</script>

<style lang="scss" scoped>
.grid {
  height: auto !important;
}
.disabled-btn {
  color: #dddddd;
  cursor: no-drop;
}
</style>

